export default __webpack_public_path__ + "4883be582904b1f2a8604b0132e02c34.jpg";